<template>
  <div>
    <NavBar />
    <CodingHandles />
    <WorkExperience />
  </div>
</template>

<script>
import NavBar from "../components/NavBar.vue";
import CodingHandles from "../components/CodingHandles.vue";
import WorkExperience from "../components/WorkExperience.vue";

export default {
  name: "Projects",
  components: {
    NavBar,
    CodingHandles,
    WorkExperience,
  },
};
</script>

<style></style>
